var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasdrLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 40,
    viewBox: "0 0 19 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Masdr Logos"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.01342 15.9581V30.8549C9.01342 31.5098 8.63394 31.8472 8.07286 31.932C7.71868 31.9852 7.43497 31.785 7.19012 31.5351C6.60103 30.9337 6.00922 30.3359 5.41471 29.7417C3.84258 28.1653 2.27016 26.5899 0.697439 25.0154C0.611075 24.9285 0.54319 24.825 0.497855 24.7112C0.452519 24.5974 0.430668 24.4757 0.433612 24.3533V7.54851C0.433612 7.1642 0.658588 6.90529 0.908862 6.65721L2.69512 4.87461L4.83917 2.73478L6.89557 0.686955C7.06092 0.518258 7.23529 0.35768 7.4169 0.206123C7.99606 -0.260275 8.83362 0.127638 8.97186 0.751908C8.99621 0.853042 9.00984 0.956453 9.01252 1.06043C9.01553 6.02693 9.01583 10.9928 9.01342 15.9581Z",
    fill: "#662577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.99006 24.0403V9.17961C9.99006 8.60586 10.2385 8.2423 10.7644 8.09706C11.142 7.99331 11.4691 8.11239 11.7375 8.37852C12.5 9.1345 13.2527 9.8995 14.0125 10.6582C14.9534 11.5982 15.8958 12.5373 16.8396 13.4755C17.3293 13.9645 17.8227 14.4516 18.3087 14.9442C18.3914 15.0272 18.4567 15.1258 18.5009 15.2342C18.5451 15.3426 18.5673 15.4586 18.5663 15.5757V32.3813C18.5702 32.5235 18.5444 32.665 18.4906 32.7967C18.4368 32.9284 18.3561 33.0475 18.2536 33.1463C17.0785 34.3197 15.9039 35.4955 14.7299 36.6736C13.73 37.672 12.7319 38.6745 11.7357 39.6813C11.5569 39.8746 11.3085 39.989 11.0452 39.9995C10.7819 40.01 10.5252 39.9157 10.3316 39.7373C10.239 39.6526 10.1635 39.5509 10.1093 39.4377C10.0263 39.2524 9.98619 39.0507 9.99186 38.8478C9.98584 34.04 9.98433 29.2326 9.98735 24.4255L9.99006 24.0403Z",
    fill: "#CB2E79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasdrLogo);
export default __webpack_public_path__ + "static/media/masdrLogo.ee795a5f.svg";
export { ForwardRef as ReactComponent };